import { Visibility } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  MenuItem,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../utils/routes";
import {
  FormatStatus,
  FormatStatusA,
  getColorByStatus,
  getColorByStatusA,
} from "../../../../../utils/functions/FormatStatus";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CalendarFilter2 } from "../../../Components/Search/Search";
import AddIcon from "@mui/icons-material/Add";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import {
  useDeleteBookServiceMutation,
  useGetBookingServiceSetupQuery,
} from "../../../../api/financeApi";
import { toast } from "react-toastify";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  fontSize: "14px",
  fontWeight: "500",
  color: "#333",
  borderBottom: "none",
}));

const statusColors = {
  Active: "bg-green-100 text-green-700",
  Inactive: "bg-red-100 text-red-700",
  Maintenance: "bg-yellow-100 text-yellow-700",
};

const SetupAService = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(10000);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bookingServiceId, setBookingServiceId] = useState();
  const [rowData, setRowData] = useState();
  const addFacilitiesUrl = URL.AddFacilities.replace(":id", bookingServiceId);
  const [anchorEl, setAnchorEl] = useState(null);
  const { data, isLoading } = useGetBookingServiceSetupQuery({
    PageSize: page,
    PageNumber: 1,
    Status: selectedStatus,
    // ApprovalStatus: 0,
  });
  // BookingServiceSetup/all?ServiceName=hello&Status=0&ApprovalStatus=0&PageSize=11000&PageNumber=1
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [onDelete, { isLoading: deleteLoading }] =
    useDeleteBookServiceMutation();
  const handleDelete = async () => {
    try {
      const res = await onDelete({ id: bookingServiceId }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        handleClose();
      } else {
        toast.error(res?.statusMessage);
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = data?.result?.items?.filter((row) => {
    const matchesSearchTerm = row?.serviceName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    return matchesSearchTerm;
  });

  return (
    <RouteLayout title="Service Setup">
      <div className="p-[20px]">
        <div className="mb-[30px]">
          <h1 className="text-[#4B664C] font-[500] text-[30px]">
            Service Setup
          </h1>
        </div>
        <div className="p-6 bg-white shadow-md rounded-lg">
          <div className="flex justify-between items-center mb-4">
            <div className="flex justify-between items-center gap-3">
              <div className="flex flex-col">
                <span>Search</span>
                <TextField
                  label="Search"
                  variant="outlined"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  size="small"
                />
              </div>
              {/* <CalendarFilter2
                name="Select Date Range"
                setStartDate={setStartDate}
                setEndDate={setEndDate}
              /> */}
              <div className="flex flex-col">
                <span>Status</span>
                <TextField
                  select
                  label="Status"
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  variant="outlined"
                  size="small"
                  sx={{
                    width: 216,
                  }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="UnderMaintenance">
                    Under Maintenance
                  </MenuItem>
                </TextField>
              </div>
            </div>
            <Button
              variant="contained"
              onClick={() =>
                navigate("/dashboard/finance/" + URL.CreateService)
              }
              style={{ backgroundColor: "#305F32", color: "#fff" }}
            >
              + New Service
            </Button>
          </div>
          <div>{isLoading && <p>Loading...</p>}</div>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>S/N</StyledTableCell>
                  <StyledTableCell>Service Name</StyledTableCell>
                  <StyledTableCell>Total</StyledTableCell>
                  <StyledTableCell>Total Available</StyledTableCell>
                  <StyledTableCell>Total Unavailable</StyledTableCell>
                  <StyledTableCell>Price Per Unit</StyledTableCell>
                  <StyledTableCell>Date Created</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData?.map((row, index) => (
                  <TableRow key={row?.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>{row?.serviceName}</StyledTableCell>
                    <StyledTableCell>{row?.total}</StyledTableCell>
                    <StyledTableCell>{row?.totalAvailable}</StyledTableCell>
                    <StyledTableCell>{row?.totalUnavailable}</StyledTableCell>
                    <StyledTableCell>
                      {FormatCurrency(row?.pricePerUnit)}
                    </StyledTableCell>
                    <StyledTableCell>
                      {FormatDateTime(row?.createdDate)}
                    </StyledTableCell>
                    <StyledTableCell>
                      <span
                        style={{
                          color: getColorByStatusA(row?.status).color,
                          backgroundColor: getColorByStatusA(row?.status)
                            .backgroundColor,
                          padding: "4px",
                          borderRadius: "4px",
                        }}
                      >
                        {FormatStatusA(row?.status)}
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <div className="flex items-center">
                        <button
                          onClick={() =>
                            navigate(
                              `/dashboard/finance/Service-details-view/${row?.id}`
                            )
                          }
                          className="bg-[#6E9170] rounded-l-md p-1"
                        >
                          <Visibility className="text-[#fff]" />
                        </button>

                        <div
                          onClick={() => {
                            setBookingServiceId(row?.id);
                            setRowData(row);
                          }}
                        >
                          <button
                            onClick={handleClick}
                            className="bg-[#4B664C] p-1 rounded-r-md"
                          >
                            <KeyboardArrowDownIcon className="text-[#fff]" />
                          </button>
                        </div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <div className="p-3 flex flex-col gap-8 h-[196px] w-[285px]">
              <div className="flex gap-3 items-center">
                <AddIcon className="w-[14px] h-[14px]" />
                <Link
                  to={`/dashboard/finance/${addFacilitiesUrl}`}
                  className="text-[#4B664C] hover:text-[#305F32]"
                >
                  Add Facilities & Components
                </Link>
              </div>
              <div className="flex gap-3 items-center">
                <img
                  className="w-[14px] h-[14px]"
                  src={editIcon}
                  alt="edit con"
                />
                <Link
                  to={`/dashboard/finance/${URL.UpdateService.replace(
                    ":data",
                    JSON.stringify(rowData)
                  )}`}
                  className="text-[#4B664C] hover:text-[#305F32]"
                >
                  Update
                </Link>
              </div>
              <div className="flex gap-3 items-center">
                <Visibility className="w-[14px] h-[14px]" />
                <Link
                  to={`/dashboard/finance/${URL.ServiceDetailsView.replace(
                    ":id",
                    bookingServiceId
                  )}`}
                  className="text-[#4B664C] hover:text-[#305F32]"
                >
                  View
                </Link>
              </div>
              <div onClick={handleDelete} className="flex gap-3 items-center">
                <img
                  className="w-[14px] h-[14px]"
                  src={bin}
                  alt="delete icon"
                />
                <button disabled={deleteLoading}>
                  {deleteLoading ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </Popover>
          <TablePagination
            component="div"
            count={filteredData?.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            className="mt-4"
          />
        </div>
      </div>
    </RouteLayout>
  );
};

export default SetupAService;
